import { useQuery } from "@tanstack/react-query";
import { DEVICE_OPTIONS_QUERY_KEY } from "@/services/device-options/device-options.constants";
import { createDeviceOptionsService } from "@/services/device-options/device-options-service.factory";
import type { DeviceOption } from "@/services/device-options/device-options.types";

const DEVICE_OPTIONS_STALE_TIME_MS = 30_000;

const deviceOptionsService = createDeviceOptionsService();

export interface UseDeviceOptionsParams {
  assetId: string;
  category: string;
}

export const useDeviceOptions = ({ assetId, category }: UseDeviceOptionsParams) => {
  const query = useQuery({
    queryKey: [...DEVICE_OPTIONS_QUERY_KEY, assetId, category],
    queryFn: () => deviceOptionsService.getOptions({ assetId, category }),
    enabled: Boolean(assetId && category),
    staleTime: DEVICE_OPTIONS_STALE_TIME_MS,
  });

  const options: DeviceOption[] = query.data?.options ?? [];
  const keyboardLayouts: string[] = query.data?.keyboardLayouts ?? [];

  return {
    options,
    keyboardLayouts,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    isEmpty: query.isSuccess && options.length === 0,
    refetch: query.refetch,
  };
};
